<template>
  <div class="row py-3 px-2 d-flex px-md-5 mx-md-4">
    <div
      v-for="plan in plans"
      v-bind:key="plan._id"
      class="col-4 plan-square py-2 px-1"
      @click="$emit('selectPlan', plan)"
    >
      <div
        :class="
          (plan.promo ? 'pb-4' : 'py-4') +
            ' h-100  section border overflow-hidden d-flex flex-column justify-content-center'
        "
      >
        <div v-if="plan.promo" class="w-100 subtext py-1 mb-auto bg-alert">
          Promo
        </div>
        <span
          v-if="plan.promo"
          class="text-rem-0-6 pb-0 text-grey-dark open-sans-bold"
          ><s>Antes {{ settings.addThousands(plan.promo_value) }}</s></span
        >
        <span
          v-if="
            user.isAgency &&
              plan.promo_value &&
              !plan.promo &&
              user.promo_on_credits &&
              user.promo_on_credits !== undefined &&
              user.promo_on_credits > 0
          "
          class="subtext pb-2"
          ><s>Regular {{ settings.addThousands(plan.promo_value) }}</s></span
        >
        <p
          :class="
            'm-0 text-rem-1-15 open-sans-medium ' +
              (!plan.promo ? 'mt-auto' : '')
          "
        >
          {{ settings.addThousands(plan.price) }}
        </p>
        <div class="text-capitalize">
          <p class="m-0 text-rem-0-8">{{ plan.type }}</p>
        </div>
        <div class="mt-2 subtext open-sans-italic text-grey-dark">
          {{ plan.days }} dias
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import settings from "@/api/settings"
export default {
  props: ["plans"],
  data() {
    return { settings }
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {},
}
</script>
